import { Component, output } from '@angular/core'
import { FormsModule } from '@angular/forms'

import { TranslatePipe } from '@ngx-translate/core'

export interface DateRange {
  dateFrom: Date
  dateTo: Date
}

@Component({
  selector: 'dhp-filter-date-range',
  templateUrl: './filter-date-range.html',
  imports: [FormsModule, TranslatePipe],
})
export class FilterDateRange {
  //region Outputs
  // The date range to filter on, with a from and to date.
  dateRangeOutput = output<DateRange | null>()
  //endregion Outputs

  //region Properties
  // Earliest date
  minDate: Date | null = null
  // Latest date
  maxDate: Date | null = null
  //endregion Properties

  //region Methods
  // Handles changes to minDate input and emits the new date range.
  onMinDateChange(target: EventTarget | null): void {
    if (target !== null) {
      const valueAsString = (target as HTMLInputElement).value
      this.minDate = valueAsString ? new Date(valueAsString) : null
    } else {
      this.minDate = null
    }

    this.onDateChange()
  }

  // Handles changes to maxDate input and emits the new date range.
  onMaxDateChange(target: EventTarget | null): void {
    if (target !== null) {
      const valueAsString = (target as HTMLInputElement).value
      this.maxDate = valueAsString ? new Date(valueAsString) : null
    } else {
      this.maxDate = null
    }

    this.onDateChange()
  }

  // Emits the current date range if both minDate and maxDate are set, otherwise emits null.
  onDateChange(): void {
    if (this.minDate === null || this.maxDate === null) {
      this.dateRangeOutput.emit(null)
      return
    }

    // Else emit the filter output
    const output = {
      dateFrom: this.minDate,
      dateTo: this.maxDate,
    }
    this.dateRangeOutput.emit(output)
  }
  //endregion Methods
}
